import 'dayjs/locale/zh-cn'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import '@/assets/styles/style.css'
import '@arco-design/web-react/dist/css/arco.css'

// import 'numeral/locales/chs'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
// import numeral from 'numeral'

import routers from './routers'

dayjs.locale('zh-cn')
dayjs.extend(duration)
// numeral.locale('chs')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<RouterProvider router={routers} />)
